import {useCallback} from 'react'

import useBeforeUnload from 'hooks/useBeforeUnload'

/**
 * `useNavigationPrompt` can be used to block the navigation based on
 * the provided `when` condition. An optional `message` can be passed.
 *
 * @param {Boolean} when The condition when to show the prompt
 * @param {String} message The message to show for the prompt
 */
const useNavigationPrompt = (when, message) => {
  const handleBeforeUnload = useCallback(
    ev => {
      if (when) {
        ev.preventDefault()
        return message
      }
    },
    [when, message]
  )
  useBeforeUnload(handleBeforeUnload)
}

export default useNavigationPrompt
